import BasicCard from '../../../components/basics/cards/BasicCard'
import { CommonAPIService } from "../../../services/apis/CommonAPIService";
import Button from 'react-bootstrap/Button'


export default function DownloadReportMapping() {

    const handleDownloadClick = () => {
        const controllerName = "ReportMapping";
        const apiName = process.env.REACT_APP_LST_API_DOMAIN + '/api/';

        CommonAPIService.callApiUsingUrlReturnBlob(`${apiName}${controllerName}/Download`)
            .then(blob => {
                // Create a URL for the blob
                const url = URL.createObjectURL(blob);

                // Create a link element and set its href attribute to the blob URL
                const link = document.createElement('a');
                link.href = url;

                // Set the link element's download attribute to the desired file name
                link.download = "ReportMappingTemplate";

                // Click the link to download the file
                link.click();

                // Clean up the URL and link elements
                URL.revokeObjectURL(url);
                link.remove();
            }, [apiName], [controllerName])
            .catch(error => console.error(error));
    };

    return (
        <BasicCard cardConfig={{ cardTitle: 'Report mapping selection', cardHeaderElement: 'h4' }}>
            <span className='brd-download-items'>
                <Button variant='primary' onClick={handleDownloadClick}>Download report mapping</Button>
            </span>
        </BasicCard>
    )
}